/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMaxSendAmountRequest} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/get_max_send_amount.pb'
import {GetMaxSendAmountResponse} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/get_max_send_amount.pb'


export const getMaxSendAmount = (request: GetMaxSendAmountRequest, options?: CashRequestOptions) => post<GetMaxSendAmountRequest, GetMaxSendAmountResponse>("/2.0/cash/get-max-send-amount", request, {...options, rejectOnError: true })